let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8NjfR")).then(() => parcelRequire('43rrr'));